import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Cog, Flame, Drill, Slice, Sparkles, CircleDot, Zap, ScanLine } from "lucide-react";

// Ícones por nome — o cadastro oficial vem do backend (GET /api/machines)
const ICONS = {
  "Romi Discovery 600": Cog,
  "Eurostec MCV520": Cog,
  "Romi Discovery 560": Cog,
  "Torno": CircleDot,
  "Fresadoras ISO30 / ISO40": Drill,
  "Plasma CNC": Sparkles,
  "Laser 6.000 W": Zap,
  "Laser de Gravação": ScanLine,
  "Serra Fita": Slice,
  "Solda MMA / MIG / TIG": Flame,
};

const FALLBACK = [
  { name: "Romi Discovery 600", qty: 1, type: "Centro de Usinagem Vertical" },
  { name: "Eurostec MCV520", qty: 1, type: "Centro de Usinagem Vertical" },
  { name: "Romi Discovery 560", qty: 3, type: "Centro de Usinagem Vertical" },
  { name: "Torno", qty: 2, type: "Torneamento" },
  { name: "Fresadoras ISO30 / ISO40", qty: 2, type: "Fresamento" },
  { name: "Plasma CNC", qty: 1, type: "Corte" },
  { name: "Laser 6.000 W", qty: 1, type: "Corte" },
  { name: "Laser de Gravação", qty: 1, type: "Gravação" },
  { name: "Serra Fita", qty: 1, type: "Corte" },
  { name: "Solda MMA / MIG / TIG", qty: 1, type: "Solda" },
];

export default function AdminMaquinas() {
  const [machines, setMachines] = useState(FALLBACK);
  useEffect(() => {
    api.get("/machines").then(({ data }) => { if (data?.length) setMachines(data); }).catch(() => {});
  }, []);

  return (
    <div data-testid="admin-machines-page">
      <h1 className="display text-3xl font-extrabold uppercase">Máquinas</h1>
      <p className="mt-1 text-sm text-slate-500">
        Parque de máquinas da Alpha Metais — mesma lista exibida no site público e usada nas Ordens de Produção.
      </p>
      <div className="mt-6 grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {machines.map((m) => {
          const Icon = ICONS[m.name] || Cog;
          return (
            <div key={m.name} className="card-tactical rounded-md p-5" data-testid={`admin-machine-${m.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
              <div className="flex items-start justify-between">
                <Icon className="w-7 h-7 text-orange-500" strokeWidth={1.5} />
                <span className="mono text-xs text-orange-400 border border-orange-900/60 bg-orange-500/10 rounded-sm px-2 py-0.5">{m.qty} un.</span>
              </div>
              <h2 className="display mt-3 text-lg font-bold uppercase tracking-wide">{m.name}</h2>
              <div className="mono mt-1 text-[11px] text-slate-500 uppercase tracking-wider">{m.type}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
